import Markdown, { type Components } from 'react-markdown'
import remarkGfm from 'remark-gfm'
import { type ChatMessagePayload } from '#app/services/ai/types.ts'
import { replaceDocumentWithLinksInLines } from '#app/services/laws-urls.ts'
import { cn } from '#app/utils/misc.tsx'

const publicArticleMarkdownComponents: Components = {
	h2: props => <h2 className="mt-12 scroll-m-20 text-2xl font-normal tracking-tight text-neutral-950" {...props} />,
	h3: props => <h3 className="mt-8 text-xl font-semibold tracking-normal text-neutral-950" {...props} />,
	p: props => <p className="my-5 leading-7 tracking-tight text-neutral-700" {...props} />,
	ul: props => <ul className="my-5 list-disc space-y-2 pl-6 leading-8 text-neutral-700" {...props} />,
	ol: props => <ol className="my-5 list-decimal space-y-2 pl-6 leading-8 text-neutral-700" {...props} />,
	li: props => <li className="pl-1" {...props} />,
	strong: props => <strong className="font-semibold text-neutral-950" {...props} />,
	blockquote: props => (
		<blockquote className="my-8 border-l-2 border-neutral-300 pl-5 text-neutral-600" {...props} />
	),
	a: props => (
		<a
			{...props}
			target="_blank"
			rel="noopener noreferrer"
			className="font-medium text-neutral-950 underline decoration-neutral-300 underline-offset-4 transition-colors hover:decoration-neutral-950"
		/>
	),
}

export function formatPublicArticleMarkdown(body: string, sourcePayloads: ChatMessagePayload | null) {
	return replaceDocumentWithLinksInLines(body, sourcePayloads).text
}

export function PublicArticleMarkdown(props: {
	body: string
	sourcePayloads: ChatMessagePayload | null
	className?: string
}) {
	const markdown = formatPublicArticleMarkdown(props.body, props.sourcePayloads)
	return (
		<div className={cn('public-article-markdown text-[17px]', props.className)}>
			<Markdown components={publicArticleMarkdownComponents} remarkPlugins={[remarkGfm]}>
				{markdown}
			</Markdown>
		</div>
	)
}
